import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import Details from "./Details";
import Risk from "./Risk";
import { User } from "../userTypes";

import { batchedApolloClient } from "app/utils/graphQlClients";

type Props = {
  external_reference: string;
  authedBankCardLoads: string;
  deviceCount: number;
  onUserChanged: (user: User) => void;
};

export default graphql<any, Props>(
  gql`
    query details($external_reference: ID) {
      user(external_reference: $external_reference) {
        external_reference
        email
        group
        created_at
        dashboard_url
        snapmin_url
        fraud_status
        customer_risk_assessment
        comments
        has_valid_deletion_request
        latest_valid_deletion_request {
          status
        }
      }
    }
  `,
  {
    options: (props) => ({
      fetchPolicy: "network-only",
      client: batchedApolloClient,
      variables: {
        external_reference: props.external_reference,
      },
    }),
  }
)((props) => (
  <BOGraphQLLoader data={props.data!}>
    <Details
      user={props.data.user}
      authedBankCardLoads={props.authedBankCardLoads}
      deviceCount={props.deviceCount}
      onUserChanged={props.onUserChanged}
      refetch={props.data.refetch}
    />
    <Risk user={props.data.user} refetch={props.data.refetch} />
  </BOGraphQLLoader>
));
